import { ReportAttachment } from "@/models/reportAttachment";
import { ReportCategory } from "@/models/reportCategory";
import { Topic } from "@/models/topic";
import { User } from "@/models/user";
import { Payment } from "./payment";

export interface Report {
  id: number;
  title: string;
  userCreatedId: number;
  image: string;
  description: string;
  amount: number;
  titleSeo: string;
  descriptionSeo: string;
  keywordSeo: string;
  favorites: any[];
  type: number;
  slug: string;
  relatedDashboardIds: number[];
  relatedReportIds: number[];
  topicIds: number[];
  havePDF: boolean;
  haveInteractive: boolean;
  haveEmbed: boolean;
  prioritize: number[];
  PDFPreview: string;
  status: number;
  publishedDate: string;
  publishedById: string;
  views: string;
  priceUSD: string;
  priceVND: string;
  priceIDO: string;
  thumbPDF: string;
  parentLanguage: string;
  language: string;
  user?: User;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  relatedReports?: Report[];
  topics?: Topic[];
  categories?: ReportCategory[];
  languages?: Report[];
  reportAttachments?: ReportAttachment[];
  payments?: Payment[];
  isPaymentEd?: boolean;
  countDownload?: number;
  userCreated?: User;
  isFavorite?: boolean;
  nameUserShared: string;
  emailUserShared: string;
  isViewBySubscription: boolean;
  powerBiId?: IPowerBI;
  workSpaceId?: IPowerBI;
  embedUrl?: string;
  bookmarkState: string;
  bookmarkName: string;
  pageCount: number;
  bookmarkLang: string;
  bookmarkCount: number;
  dashboardId: number;
  reportAttachmentsOption: string[];
  isHot: boolean;
  order?: number;
  orderHot?: number;
  isPrivate?: boolean;
  embedUrlDemo?: string;
  embedUrlProduction?: string;
}
export interface IPowerBI {
  id: string;
  name: string;
}
export interface StatusReport {
  status: number;
}

export enum REPORT_TYPE {
  FREE = 1,
  STANDARD,
  PREMIUM,
}

export interface typeOption {
  id: REPORT_TYPE;
  name: string;
}

export const typesOptions: typeOption[] = [
  { id: REPORT_TYPE.FREE, name: "Free" },
  //{id: REPORT_TYPE.STANDARD, name: 'Standard'},
  { id: REPORT_TYPE.PREMIUM, name: "Premium" },
];

export enum REPORT_STATUS {
  NOT_ACTIVE = 0,
  ACTIVE,
  COMING_SON,
}

export interface statusOption {
  id: REPORT_STATUS;
  name: string;
}

export const statusOptions: statusOption[] = [
  { id: REPORT_STATUS.NOT_ACTIVE, name: "Not active" },
  { id: REPORT_STATUS.ACTIVE, name: "Active" },
  { id: REPORT_STATUS.COMING_SON, name: "Coming soon" },
];

export interface methodOption {
  id: number;
  name: string;
}

export const methodOptions: methodOption[] = [
  { id: 1, name: "Youtube" },
  { id: 2, name: "Supademo" },
];
export interface GetReports {
  take: number;
  page: number;
  keyword: string;
  sortedField?: string;
  isDescending?: boolean;
}

export interface reportMinimal {
  reportId?: number;
  token?: string;
  slug?: string;
}

export enum TYPE_FAVORITE {
  FAVORITE = 1,
  SHARE,
}

export enum EPrioritizeReport {
  PDF = 1,
  POWERBI = 2,
  EMBED = 3,
}
